export const gitCommit = '701f1c22'
